import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { SiteHeader } from '@/components/generals/site-header'
import { SiteFooter } from '@/components/generals/site-footer'
import { JsonLd } from '@/components/generals/json-ld'
import { Analytics } from '@/components/generals/analytics'
import { CookieBanner } from '@/components/generals/cookie-banner'

import { graph, organizationSchema, websiteSchema } from '@/lib/structured-data'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col bg-background'>
            <JsonLd data={graph([organizationSchema(), websiteSchema()])} />

            {/* Mounted here rather than in _app so the admin panel is never tracked. */}
            <Analytics />

            <SiteHeader />

            <main className='flex-1'>
                {children}
            </main>

            <SiteFooter />

            <CookieBanner />
        </div>
    )
}
